export const protocol = "https";
export const host =
  "api.tapdigital.de";
export const port = "";
export const trailUrl = "";
